import React, { useState } from "react";
import { ReactEditor, useSelected, useSlateStatic } from "slate-react";
import { Button, Popover } from "antd";
import CustomEditor from "../CustomEditorConfig";

const DicoLeaf = (props) => {
  const selected = useSelected();
  const editor = useSlateStatic();

  const [hovered, setHovered] = useState(false);
  const [location, setLocation] = useState();

  const handleHoverChange = (open) => {
    setHovered(open);
  };

  const deleteDef = () => {
    if (location !== undefined) CustomEditor.toggleDicoMarkAt(editor, location);
  };

  const hoveredContent = () => {
    return (
      <div>
        <p>{props.leaf.dico.definition}</p>
        <Button danger type="link" onClick={deleteDef}>
          Supprimer
        </Button>
      </div>
    );
  };

  return (
    <Popover
      style={{ width: 500 }}
      content={hoveredContent}
      trigger="hover"
      open={hovered}
      onOpenChange={handleHoverChange}
    >
      <span
        onMouseEnter={(e) => {
          const node = ReactEditor.toSlateNode(editor, e.target);
          console.log(node);
          setLocation(ReactEditor.findPath(editor, node));
        }}
        contentEditable={false}
        style={{
          backgroundColor: "rgba(0,0,0,0.5)",
          color: "white",
          padding: "2px 6px",
          borderRadius: "2px",
          fontSize: "0.9em",
          // ${selected && "box-shadow: 0 0 0 3px #ddd;"}
        }}
        data-playwright-selected={selected}
      >
        {props.children}
      </span>
    </Popover>
  );
};

export default DicoLeaf;
